import Page from 'modules/app/components/Page'
import PageContainer from 'components/shared/PageContainer'
import React from 'react'
import image from 'images/banners/pdfsbanner.png'
import style from './PolicyPage.module.scss'

type Props = {
  children: React.ReactNode;
  title: string
}

export default function PolicyPage({
  children,
  title,
}: Props) {
  return (
    <Page>
      <PageContainer>
        <h1>{title}</h1>
        <img
          style={{
            position: 'absolute', top: 0, left: 0, width: '100%', zIndex: -1,
          }}
          src={image}
          alt=""
        />
        <div
          className={style.main}
        >
          {children}
        </div>
      </PageContainer>
    </Page>

  )
}
